<template>
    <DxDataGrid :data-source="dsReports" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="ID" @rowClick="onReportRowClick" :search-expr="['nume', 'query', 'modul']">
		<DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>

		<DxColumn data-field="nume" caption="Nume"/>
		<DxColumn data-field="modul" caption="Modul" :visible="false" :allow-search="false"/>
		<DxColumn data-field="queryType" caption="Query Type" :calculate-display-value="calcQueryType" :allow-search="false"/>
		<DxColumn data-field="query" caption="Query" :allow-search="false"/>
		<DxColumn data-field="layout" :visible="false" :allow-search="false"/>
		<DxColumn data-field="options" :visible="false" :allow-search="false"/>
		<DxColumn data-field="parameters" :visible="false" :allow-search="false"/>
		<DxColumn data-field="layoutXml" :visible="false" :allow-search="false"/>
		
		<DxToolbar>
			<DxItem name="searchPanel"/>
			<DxItem location="before" widget="dxDropDownButton" :options="modelButtonOptions"/>
		</DxToolbar>
    </DxDataGrid>
	<DxPopup v-model:visible="isPopupVisible" 
			:width="500" 
			:height="'auto'"
			:show-close-button="true"
			:hide-on-outside-click="true">
		<template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                {{selectedReportName}}
            </div>
        </template>
		<div class="popup-wrapper">
			<DxForm :key="formKey"
					:form-data="dynamicFormData"
					:items="formItems"
					:col-count="1"/>
			<div style="margin-top: 12px;">
				<div class="report-popup-actions">
					<div class="report-popup-action">
						<DxButton text="Execută Raport"
							type="default"
							width="100%"
							:disabled="!selectedDesignID"
							@click="executeReport"/>
					</div>
					<div class="report-popup-action">
						<DxButton text="Copiază link"
							icon="link"
							type="normal"
							width="100%"
							style="flex: 1;"
							@click="copyReportShareUrl"/>
					</div>
				</div>
				<div v-if="!selectedDesignID" style="color: red; font-size: 12px; margin-top: 5px; text-align: center;">
					* Acest raport nu are un layout definit.
				</div>
			</div>
		</div>
	</DxPopup>
	<DxPopup :visible="isPdfPreviewVisible" :width="1700" :height="900" :hide-on-outside-click="true">
		<template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Previzualizare Raport
            </div>
        </template>

		<div style="display:flex; flex-direction:column; height:100%;">
			<div style="flex:1; border-top:1px solid #ddd;">
				<iframe
					v-if="pdfBlobUrl"
					:src="pdfBlobUrl"
					style="width:100%; height:100%; border:0;"
				></iframe>
			</div>
			<div style="display:flex; justify-content: center; align-items: center; gap:16px; padding:12px;">
				<DxButton text="Descarcă PDF" icon="download" type="success" @click="downloadPreviewPdf" />
				<DxButton text="Închide" type="danger" icon="close" @click="closePdfPreview" />
			</div>
		</div>
	</DxPopup>
</template>
<script lang="ts">
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxToolbar,
  DxItem,
  DxItem as DxFormItem,
  DxForm as DxFormGrid,
  DxSearchPanel,
} from 'devextreme-vue/data-grid';
import Guid from 'devextreme/core/guid'
import DxDateBox from 'devextreme-vue/date-box';
import AppSetting from '@/settings/appSettings';
import { defineComponent } from 'vue';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { DxButton } from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import { DxForm, DxSimpleItem } from "devextreme-vue/form"
import DxPopup from 'devextreme-vue/popup'

export default defineComponent({
    components: {
        DxDataGrid,
		DxSelection,
		DxFilterRow,
		DxPaging,
		DxLoadPanel,
		DxSorting,
		DxSearchPanel,
		DxColumn,
		DxToolbar,
		DxItem,
		DxForm,
		DxDateBox,
		DxSimpleItem,
		DxButton,
		DxPopup,
    },
    data() {
      return {
        dsReports: null as any,
		modelButtonOptions: {
			icon: 'bulletlist',
			text: 'Selectează un modul: ',
			displayExpr: 'id',
			valueExpr: 'id',
			stylingMode: 'outlined',
			items: [
				{ id: 'BUG' },
				{ id: 'COM' },
				{ id: 'CON' },
				{ id: 'CRM' },
				{ id: 'DOC' },
				{ id: 'DOC1' },
				{ id: 'ERP' },
				{ id: 'GES' },
				{ id: '_GES' },
				{ id: 'PAR' },
				{ id: 'PER' },
				{ id: 'PRO' },
				{ id: 'SAFT' },
				{ id: 'SAL' },
				{ id: '_SAL' },
				{ id: 'SRV' }
			],
		},
		isPopupVisible: false,
		selectedReportName: '',
		selectedReportID: null,
		selectedDesignID: null,
		currentParameters: [],
		dynamicFormData: {} as Record<string, any>,
		formItems: [] as any[],
		formKey: "" as string,
		popupToolbarItems: [
			{
				toolbar: "bottom",
				location: "after",
				widget: "dxButton",
				options: {
					text: "Execută",
					type: "default",
					onClick: () => {

					}
				}
			}
		],
		pdfBlobUrl: null as string | null,
		isPdfPreviewVisible: false,
		pdfFileName: "" as string,
      }
    },
    methods: {
      	loadData() {
        	this.dsReports = new DataSource({
				store: {
					type: 'odata',
					url: AppSetting.API_Url_RapoarteOdata + `ERP_Reports`,
					key: 'ID',
					keyType: "Guid",
					version: 4,
					beforeSend: (e: any) => {
						e.headers = {
						"Content-Type": "application/json",
						"Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
						};
					},
				}
			})
        },
		onModuleClick(e) {
			const selectedId = e.itemData.id

			e.component.option('text', 'Modul: ' + selectedId)

			if (this.dsReports) {
				this.dsReports.filter(['modul', '=', selectedId])
				this.dsReports.load()
			}
		},
		calcQueryType(rowData: any) {
			const queryType = rowData.queryType
			if (queryType == 1) {
				return 'Procedura Stocata'
			}

			return 'Query SQL'
		},
		async onReportRowClick(e: any) {
			await this.openReportPopup(e.data)
		},
		async openReportPopup(report: any, prefillData: Record<string, any> | null = null) {
			this.selectedReportName = report.nume;
			this.selectedReportID = report.ID;
			this.selectedDesignID = null

			console.log("prefillData primit:", prefillData);

			const dsDesign = new DataSource({
				store: {
					type: 'odata',
					url: AppSetting.API_Url_RapoarteOdata + 'ERP_ReportsDesigner',
					key: 'ID',
					version: 4,
					beforeSend: (e: any) => {
						e.headers = { "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt") };
					}
				},
				filter: ['ReportID', '=', new Guid(report.ID)],
				paginate: false
			})

			await dsDesign.load().then((items: any[]) => {
				if (items && items.length > 0) {
					this.selectedDesignID = items[0].ID;
					console.log("Design automat identificat:", this.selectedDesignID);
				} else {
					console.warn("Acest raport nu are un design asociat în ERP_ReportsDesigner.");
				}
			}).catch(error => {
				console.error("Eroare la căutarea design-ului:", error);
			});

			try {
				let baseUrl = AppSetting.API_Url_RapoarteOdata;
				baseUrl = baseUrl.replace(/\/v1\/?$/i, '/');
				if (!baseUrl.endsWith('/')) baseUrl += '/';

				const paramsUrl = `${baseUrl}api/Report/GetReportParameters?reportID=${report.ID}`;
				const paramsResp = await fetch(paramsUrl, {
					method: 'GET',
					headers: {
						"Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
						"Content-Type": "application/json"
					}
				});
				if (!paramsResp.ok) throw new Error(`GetReportParameters status: ${paramsResp.status}`);
				const xmlParams = await paramsResp.json();

				let missingParamsRaw: any[] = [];
				if (report.queryType === 1) {
					const missingUrl = `${baseUrl}api/Report/GetMissingSqlParameters?reportID=${report.ID}`;
					const missingResp = await fetch(missingUrl, {
					method: 'GET',
					headers: { "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt") }
					});

					if (missingResp.ok) {
						missingParamsRaw = await missingResp.json();
					}
				}

				const missingAsForm = (missingParamsRaw || []).map(mp => {
					const hidden = true
					const netType = mp.Type || "String";

					const editorType =
						netType === "Boolean" ? "dxCheckBox" :
						(netType === "DateTime" ? "dxDateBox" :
						(netType === "Decimal" || netType === "Int16" || netType === "Int32" || netType === "Int64" || netType === "Double" || netType === "Single" ? "dxNumberBox" :
						"dxTextBox"));

					return {
						FieldName: mp.Name,
						Label: mp.Name,
						Value: null,
						Options: [],
						IsReadOnly: true,
						EditorType: editorType,
						Type: netType,
						__source: "missing",
    					__hidden: hidden
					};
				});

				const map = new Map<string, any>();

				(xmlParams || []).forEach((p: any) => {
					const key = (p.FieldName || "").toLowerCase();
					map.set(key, { ...p, Type: p.Type || undefined });
				});

				missingAsForm.forEach((p: any) => {
					const key = (p.FieldName || "").toLowerCase();
					if (!map.has(key)) {
						map.set(key, p);
					}
				});

				const allParams = Array.from(map.values());

				allParams.forEach((p: any) => {
					if ((p.FieldName || "").toLowerCase() === "utilizator") {
						const current = p.Value != null ? String(p.Value).trim() : "";
						if (!current) {
							p.Value = localStorage.getItem("ERA_UserName") || "";
						}
					}
				});

				const newData: Record<string, any> = {};
				allParams.forEach((p: any) => {
					newData[p.FieldName] = p.Value ?? null;
				});
				if (prefillData) {
					this.applyPrefillData(allParams, newData, prefillData);
				}
				this.dynamicFormData = newData;

				this.currentParameters = allParams;

				this.formItems = allParams.filter((p:any) => !p.__hidden).map((p: any) => {
					const isCheckbox = p.EditorType === 'dxCheckBox';
					return {
						dataField: p.FieldName,
						editorType: p.EditorType,
						cssClass: isCheckbox ? 'center-checkbox-item' : undefined,
						label: { text: p.Label, visible: !isCheckbox },
						editorOptions: {
							...this.getEditorOptions(p)
						}
					};
				});

				this.formKey = report.ID ? `${report.ID}_${Date.now()}` : String(Date.now());
				this.isPopupVisible = true;
			} catch (error: any) {
				console.error("Eroare la apelul parametrilor:", error);
				notify("Eroare la preluarea parametrilor!", "error", 2000);
			} 
		},
		applyPrefillData(allParams: any[], targetData: Record<string, any>, prefillData: Record<string, any>){
			const paramsMap = new Map<string, any>();

			allParams.forEach((p: any) => {
				paramsMap.set((p.FieldName || "").toLowerCase(), p);
			});

			Object.keys(prefillData || {}).forEach((key) => {
				const param = paramsMap.get(key.toLowerCase());
				if (!param) return;

				const rawValue = prefillData[key];
				targetData[param.FieldName] = this.convertPrefillValue(rawValue, param);
			});
		},
		convertPrefillValue(rawValue: any, param: any) {
			if (rawValue == null) return null;

			const dotNetType = (param.Type || "").toString();
			const editorType = param.EditorType;

			if (dotNetType === "Boolean" || editorType === "dxCheckBox") {
				if (typeof rawValue === "boolean") return rawValue;
				const val = String(rawValue).toLowerCase().trim();
				return val === "true" || val === "1";
			}

			if (dotNetType === "DateTime" || editorType === "dxDateBox") {
				if (rawValue instanceof Date) return rawValue;
				const d = new Date(rawValue);
				return isNaN(d.getTime()) ? null : d;
			}

			const isNumeric =
				dotNetType === "Decimal" ||
				dotNetType === "Int16" ||
				dotNetType === "Int32" ||
				dotNetType === "Int64" ||
				dotNetType === "Double" ||
				dotNetType === "Single" ||
				editorType === "dxNumberBox";

			if (isNumeric) {
				const normalized = String(rawValue).replace(",", ".");
				const num = Number(normalized);
				return isNaN(num) ? null : num;
			}

			return rawValue;
		},
		async handleReportLinkFromUrl() {
			console.log("handleReportLinkFromUrl START");

			try {
				const routeQuery = (this as any).$route?.query;
				const searchParams = routeQuery
					? new URLSearchParams(
						Object.entries(routeQuery).reduce((acc: Record<string, string>, [k, v]) => {
							acc[k] = Array.isArray(v) ? String(v[0]) : String(v ?? "");
							return acc;
						}, {})
					)
					: new URLSearchParams(window.location.search);

				const reportId = searchParams.get("reportId");
				const prefillRaw = searchParams.get("prefill");

				if (!reportId) return;

				let prefillData: Record<string, any> | null = null;

				if (prefillRaw) {
					try {
						prefillData = JSON.parse(prefillRaw);
					} catch {
						try {
							prefillData = JSON.parse(decodeURIComponent(prefillRaw));
						} catch (err) {
							console.warn("Prefill invalid în URL", err);
						}
					}
				}

				const report = await this.dsReports.store().byKey(reportId);

				if (!report) {
					notify("Raportul din link nu a fost găsit.", "warning", 2500);
					return;
				}

				await this.openReportPopup(report, prefillData);

				console.log("reportId din URL:", reportId);
				console.log("prefillRaw din URL:", prefillRaw);
				console.log("report găsit:", report);

				window.history.replaceState({}, document.title, window.location.pathname);
			} catch (error) {
				console.error("Eroare la procesarea link-ului:", error);
        		notify("Nu s-a putut deschide raportul din link.", "error", 2500); 
			}
		},	
		getEditorOptions(param: any) {
			const editorType = param.EditorType;

			if (editorType === "dxDateBox") {
				return { 
					displayFormat: "dd.MM.yyyy", 
					type: "date", 
					useMaskBehavior: true,
					dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss" 
				};
			}
			
			if (editorType === "dxNumberBox") {
				return { showSpinButtons: true };
			}

			if (editorType === "dxSelectBox") {
				const options = Array.isArray(param.Options) ? param.Options : [];
				const ds = new DataSource({
					store: new ArrayStore({
						data: options,
						key: 'Id'
					}),
					paginate: true,
					pageSize: 50
				});

				return {
					searchEnabled: true,
					showClearButton: true,
					valueExpr: 'Id',
					displayExpr: 'Text',
					placeholder: "Selectati...",
					readOnly: param.IsReadOnly,
					dataSource: ds,
				};
			}

			if (editorType === "dxCheckBox") {
				return {
					text: param.Label
				};
			}

			return {};
		},
		async executeReport() {
			if (!this.selectedReportID) {
				notify("Eroare: Lipsă ID Raport.", "error", 2000);
				return;
			}

			if (!this.selectedDesignID) {
				notify("Acest raport nu are un design (layout) configurat! Nu se poate genera PDF.", "error", 3000);
				return;
			}

			const hasNulls = this.currentParameters.some((p: any) => {
				const v = this.dynamicFormData[p.FieldName];

				if (p.EditorType === "dxCheckBox") return false;

				const t = (p.Type || "").toString();

				if (t === "Guid" || t === "String") return false;

				if ((p.FieldName || "").toLowerCase() === "utilizator") return false;

				return v == null || v === "";
			});

			if (hasNulls) {
				notify("Completează toți parametrii înainte de execuție.", "warning", 2500);
				return;
			}

			try {
				const payload = this.currentParameters.map((param: any) => {
					const rawValue = this.dynamicFormData[param.FieldName];

					let dotNetType = param.Type || "String";
					let stringValue: string | null = null;

					if (!param.Type) {
						switch (param.EditorType) {
						case "dxDateBox": dotNetType = "DateTime"; break;
						case "dxCheckBox": dotNetType = "Boolean"; break;
						case "dxNumberBox": dotNetType = "Decimal"; break;
						case "dxSelectBox": {
							const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
							const rawStr = rawValue != null ? String(rawValue) : "";
							dotNetType = guidRegex.test(rawStr) ? "Guid" : "String";
							break;
						}
						default: dotNetType = "String"; break;
						}
					}

					if (dotNetType === "DateTime") {
						if (rawValue == null || rawValue === "") {
							stringValue = null
						} else if (rawValue instanceof Date) {
							const pad = (n: number) => String(n).padStart(2, "0");
							const y = rawValue.getFullYear();
							const m = pad(rawValue.getMonth() + 1);
							const d = pad(rawValue.getDate());
							const hh = pad(rawValue.getHours());
							const mm = pad(rawValue.getMinutes());
							const ss = pad(rawValue.getSeconds());
							stringValue = `${y}-${m}-${d}T${hh}:${mm}:${ss}`;
						} else [
							stringValue = String(rawValue).trim()
						]
					}
					else if (dotNetType === "Boolean") {
						stringValue = rawValue ? "true" : "false";
					}
					else {
						const isNumeric =
							dotNetType === "Decimal" || dotNetType === "Int16" || dotNetType === "Int32" || dotNetType === "Int64" ||
							dotNetType === "Double" || dotNetType === "Single";

						if (isNumeric && typeof rawValue === "string") {
							const normalized = rawValue.replace(",", ".");
							stringValue = normalized !== "" ? normalized : null;
						} else {
							stringValue = rawValue != null && rawValue !== "" ? rawValue.toString() : null;
						}
					}

					return { Name: param.FieldName, Value: stringValue, Type: dotNetType };
				});

				let baseUrl = AppSetting.API_Url_RapoarteOdata.replace(/\/v1\/?$/i, '/');
				if (!baseUrl.endsWith('/')) baseUrl += '/';
				
				let url = `${baseUrl}api/Report/GetReport?reportID=${this.selectedReportID}&reportDesignID=${this.selectedDesignID}`;

				notify("Se generează PDF-ul...", "info", 2000);

				const response = await fetch(url, {
					method: 'POST',
					headers: {
						"Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
						"Content-Type": "application/json"
					},
					body: JSON.stringify(payload)
				});

				if (!response.ok) {
					const errorText = await response.text();
					throw new Error(errorText || "Eroare server la generare");
				}

				const blob = await response.blob();

				if (this.pdfBlobUrl) {
				window.URL.revokeObjectURL(this.pdfBlobUrl);
				this.pdfBlobUrl = null;
				}

				this.pdfFileName = `${this.selectedReportName || "Raport"}.pdf`;
				this.pdfBlobUrl = window.URL.createObjectURL(blob);

				this.isPopupVisible = false;

				this.isPdfPreviewVisible = true;

				notify("Raport generat. Previzualizare disponibilă.", "success", 2000);
			} catch (error) {
				console.error("Eroare:", error);
				notify("Eroare: " + error.message, "error", 5000);
			} 
		},
		closePdfPreview() {
			this.isPdfPreviewVisible = false;

			if (this.pdfBlobUrl) {
				window.URL.revokeObjectURL(this.pdfBlobUrl);
				this.pdfBlobUrl = null;
			}
		},
		downloadPreviewPdf() {
			if (!this.pdfBlobUrl) return;

			const link = document.createElement('a');
			link.href = this.pdfBlobUrl;
			link.download = this.pdfFileName || 'Raport.pdf';
			document.body.appendChild(link);
			link.click();
			link.remove();
		},
		buildReportPrefillPayload() {
			const payload: Record<string, any> = {};

			(this.currentParameters || []).forEach((param: any) => {
				const fieldName = param.FieldName;
				const rawValue = this.dynamicFormData[fieldName];

				if (rawValue === undefined) return;

				if (rawValue === null || rawValue === "") {
					payload[fieldName] = null;
					return;
				}

				if (param.EditorType === "dxDateBox") {
					if (rawValue instanceof Date) {
						const pad = (n: number) => String(n).padStart(2, "0");
						const y = rawValue.getFullYear();
						const m = pad(rawValue.getMonth() + 1);
						const d = pad(rawValue.getDate());
						const hh = pad(rawValue.getHours());
						const mm = pad(rawValue.getMinutes());
						const ss = pad(rawValue.getSeconds());

						payload[fieldName] = `${y}-${m}-${d}T${hh}:${mm}:${ss}`;
					} else {
						payload[fieldName] = String(rawValue);
					}
					return;
				}

				if (param.EditorType === "dxCheckBox") {
					payload[fieldName] = !!rawValue;
					return;
				}

				payload[fieldName] = rawValue;
			});

			return payload;
		},
		buildReportShareUrl() {
			if (!this.selectedReportID) {
				throw new Error("Nu există un raport selectat.");
			}

			const prefillPayload = this.buildReportPrefillPayload();
			const prefill = encodeURIComponent(JSON.stringify(prefillPayload));

			const origin = window.location.origin;
			const path = (this as any).$route?.path || window.location.pathname;

			return `${origin}${path}?reportId=${this.selectedReportID}&prefill=${prefill}`;
		},
		async copyReportShareUrl() {
			try {
				const url = this.buildReportShareUrl();

				if (navigator.clipboard && window.isSecureContext) {
					await navigator.clipboard.writeText(url);
				} else {
					const textarea = document.createElement("textarea");
					textarea.value = url;
					textarea.style.position = "fixed";
					textarea.style.left = "-999999px";
					textarea.style.top = "-999999px";
					document.body.appendChild(textarea);
					textarea.focus();
					textarea.select();
					document.execCommand("copy");
					textarea.remove();
				}

				notify("Link-ul a fost copiat în clipboard.", "success", 2000);
			} catch (error: any) {
				console.error("Eroare la copierea link-ului:", error);
				notify("Nu s-a putut copia link-ul.", "error", 2500);
			}
		},
    },
    async mounted() {
		console.log("MOUNTED RAPOARTE");
    	console.log("window.location.href =", window.location.href);
    	console.log("window.location.search =", window.location.search);
    	console.log("$route =", (this as any).$route);

      	this.loadData()

	  	await this.handleReportLinkFromUrl()
    },
	watch: {
		'$route.fullPath': {
			async handler() {
				console.log("ROUTE CHANGED:", (this as any).$route?.fullPath);
				await this.handleReportLinkFromUrl();
			}
		}
	},
	created() {
		console.log("CREATED RAPOARTE");
		this.modelButtonOptions.onItemClick = this.onModuleClick
	}
})
</script>
<style>
	.center-checkbox-item .dx-field-item-content {
		display: flex !important;
		flex-direction: row !important;
		justify-content: center !important; 
		align-items: center !important;     
		width: 100% !important;
	}

	.center-checkbox-item .dx-checkbox {
		width: auto !important;
		display: inline-flex !important;
	}

	.center-checkbox-item .dx-checkbox-text {
		padding-left: 10px !important;
	}

	.report-popup-actions {
		display: flex;
		gap: 10px;
		width: 100%;
	}

	.report-popup-action {
		flex: 1 1 0;
		min-width: 0;
	}
</style>